import Bugsnag from '@bugsnag/js'
import { bugsnagOnError } from './bugsnag_noise_filter'

// Initialize Bugsnag with API key from environment variables
const bugsnagApiKey = process.env.BUGSNAG_API_KEY

if (!bugsnagApiKey) {
  console.warn('Bugsnag API key is not set. Error reporting will be disabled.')
} else {
  window.Bugsnag = Bugsnag.start({
    apiKey: bugsnagApiKey,
    releaseStage: process.env.NODE_ENV || 'development',
    enabledReleaseStages: ['staging', 'production'],
    onError: bugsnagOnError,
  })
}

export default window.Bugsnag
